import React, { useState, useEffect, useContext, useRef } from "react";
import api from "../../services/api";
import makeStyles from "@mui/styles/makeStyles";
import { AuthContext } from "../../context/Auth/AuthContext";
import MainContainer from "../MainContainer";
import MainHeader from "../MainHeader";
import Title from "../Title";
import { Button, Divider, TextField, Container, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import Autocomplete, {
    createFilterOptions,
} from "@mui/material/Autocomplete";
import { i18n } from "../../translate/i18n";

import { toast } from "react-toastify";
import toastError from "../../errors/toastError";

const filter = createFilterOptions({
    trim: true,
});

const MessageForwardModal = ({ Open, onClose, title, onConfirm, message }) => {

    const { user: loggedInUser } = useContext(AuthContext);

    const useStyles = makeStyles(theme => ({
        MainContainer: {
            maxHeight: 800,
            maxWidth: 600,
            minHeight: 400,
            minWidth: 200,
        },
        textField: {
            marginTop: theme.spacing(6),
            marginRight: theme.spacing(1),
            width: 200,
        },
        wrapIcon: {
            verticalAlign: 'middle',
            display: 'inline-flex'
        },
    }));

    const classes = useStyles();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchParam, setSearchParam] = useState("");
    const [selectedContact, setSelectedContact] = useState(null);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        if (!Open || searchParam.length < 3) {
            setLoading(false);
            if (!Open) setOptions([]);
            return;
        }
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    const { data } = await api.get("contacts", {
                        params: { searchParam },
                    });
                    setOptions(data.contacts || []);
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                    toast.error(err);
                }
            };

            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchParam, Open]);

    const handleSelectOption = (e, newValue) => {
        if (!newValue) {
            setSelectedContact(null);
            return;
        }
        if (typeof newValue === "string") return;
        if (newValue.id) {
            setSelectedContact(newValue);
        }
    };

    const createAddContactOption = (filterOptions, params) => {
        const filtered = filter(filterOptions, params);
        return filtered;
    };

    const getOptionLabel = option => {
        if (typeof option === "string") return option;
        if (option.number) {
            return `${option.name || option.number} - ${option.number}`;
        }
        return option.name || "";
    };

    const renderOption = (props, option) => {
        const label = option.number
            ? `${option.name || option.number} - ${option.number}`
            : option.name || "";
        return (
            <li {...props}>
                {label}
            </li>
        );
    };


    const handleSubmit = async e => {
        e.preventDefault();

        if (!selectedContact?.id) {
            toast.error("Selecione um contato para encaminhar.");
            return;
        }

        const t = await api.get(`/ticketContact/${selectedContact.id}`, {
            params: `${selectedContact.id}`,
        });
        const ticket = t?.data;

        const GetFilename = (url) => {
            if (!url) return "";
            const normalized = String(url).replace(/\\/g, "/");
            if (normalized.includes("/public/")) {
                return normalized.split("/public/").pop() || "";
            }
            const parts = normalized.split("/");
            return parts[parts.length - 1] || "";
        };

        const buildForwardPayload = () => {
            const payload = {
                body: message.body || "",
                fromMe: true,
                read: true,
                isForwarded: true,
            };

            const fileName = GetFilename(message.mediaUrl);
            if (fileName) {
                payload.medias = { fileName };
            }

            return payload;
        };

        // se o ticket existe enviar mensagem nele, caso contrario abrir novo ticket 
        // VALIDAR SE USUARIO E ADMINISTRADOR PARA PODER ENVIAR PARA TICKETS QUE NAO SAO DELE user.profile != admin
        if (ticket?.id && (ticket?.userId === user.id || user.profile === "admin" || ticket?.status === "pending")) {
            const data = buildForwardPayload();
            try {
                await api.post(`/messages/forward/${ticket.id}`, data);
                toast.success("Mensagem enviada ao ticket " + `${ticket?.id}`);
                handleClose();
            } catch (err) {
                toastError(err);
            }

        } else if (ticket?.id && (ticket?.userId != user.id)) {
            toast.error("O contato já possui Ticket ativo com outro operador!");
        } else if (ticket === "undefined" || !ticket) {
            const TicketData = {
                contactId: selectedContact?.id,
                status: 'open',
                queueId: null,
                userId: user.id,
            };
            const sn = await api.post(`/tickets`, TicketData);
            const sendTicket = sn.data;

            if (sendTicket?.id) {
                const data = buildForwardPayload();
                try {
                    await api.post(`/messages/forward/${sendTicket.id}`, data);
                    toast.success("Ticket criado com sucesso!");
                } catch (err) {
                    toastError(err);
                }
            } else {
                toast.error("Erro ao criar ticket de encaminhmento!");
            }

            handleClose();

        }
    }
    const handleClose = () => {
        setSearchParam("");
        setSelectedContact(null);
        setOptions([]);
        onClose();
    };

    return (
        <Dialog
            open={Open}
            onClose={handleClose}
            fullWidth
            className={MainContainer}
        >
            <MainContainer className={classes.mainContainer}>
                <MainHeader>
                    <Title>{title}</Title>
                </MainHeader>
                <Divider />
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <Container>
                            <Autocomplete
                                options={options}
                                loading={loading}
                                style={{ width: "90%", margin: "auto" }}
                                clearOnBlur
                                autoHighlight
                                clearOnEscape
                                getOptionLabel={getOptionLabel}
                                renderOption={renderOption}
                                filterOptions={createAddContactOption}
                                isOptionEqualToValue={(option, value) =>
                                    option?.id != null && option.id === value?.id
                                }
                                onInputChange={(_, value, reason) => {
                                    if (reason === "input") {
                                        setSearchParam(value);
                                        if (!value) setSelectedContact(null);
                                    }
                                }}
                                onChange={(e, newValue) => handleSelectOption(e, newValue)}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label={i18n.t("newTicketModal.fieldLabel")}
                                        variant="outlined"
                                        autoFocus
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loading ? (
                                                        <CircularProgress color="inherit" size={20} />
                                                    ) : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                            />

                        </Container>

                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => onClose(false)}
                                color="inherit"
                            >
                                {i18n.t("confirmationModal.buttons.cancel")}
                            </Button>
                            <Button type='submit'
                                variant="contained"
                                color="primary"
                                onClick={() => onConfirm()}
                            >
                                {i18n.t("confirmationModal.buttons.confirm")}
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
                <DialogContent>
                    <strong style={{bold: true}} > Obs:</strong> As mensagens so podem ser encaminhadas para contatos com ticket aberto em seu nome ou por um administrador!
                </DialogContent>
                <Divider />
            </MainContainer>
        </Dialog >
    )

}
export default MessageForwardModal; 
